// Salary payments (/salary-payment). The Excel file stays Turkish.
const salaryPayment = {
  page: {
    title: 'Salary Payments',
    subtitle: '{{period}}: employees’ current salaries, payment status and bulk payment.',
  },
  actions: {
    excel: 'Download Table',
    excelHint: 'Download the salary list as Excel',
    bulk: 'Pay All ({{count}})',
    bulkHint: 'Preview and pay the unpaid salaries of {{period}}',
  },
  stats: {
    total: 'Salary Records',
    totalShort: 'Records',
    paid: 'Paid Salaries',
    paidShort: 'Paid',
    unpaid: 'Unpaid Salaries',
    unpaidShort: 'Unpaid',
    toPay: 'Net Amount to Pay',
    toPayShort: 'To pay',
    share: '{{percent}}% of records',
  },
  toolbar: {
    search: 'Search by name or surname…',
    searchShort: 'Search employees…',
    status: 'Payment status',
    paid_all: 'All',
    paid_true: 'Paid',
    paid_false: 'Unpaid',
    month: 'Payment period',
    currentMonth: 'Back to this month',
  },
  status: {
    paid: 'Paid',
    unpaid: 'Unpaid',
  },
  columns: {
    employeeName: 'First Name',
    employeeSurname: 'Last Name',
    isCurrentMonthPaid: 'Payment Status',
    lastPaymentDate: 'Last Payment Date',
    grossSalary: 'Gross Salary',
    sskEmployeeShare: 'SSI Employee Share (14%)',
    unemploymentEmployeeShare: 'Unemployment Ins. Employee (1%)',
    stampTax: 'Stamp Tax',
    totalDeductions: 'Total Deductions',
    netSalary: 'Net Salary',
    sskEmployerShare: 'SSI Employer Share (15.5%)',
    unemploymentEmployerShare: 'Unemployment Ins. Employer (2%)',
    suggestedCost: 'Total Cost',
    contractDate: 'Contract Date',
  },
  table: {
    listLabel: 'Salary records',
    empty: 'No salary records match the filters',
    rangeOf: 'of {{total}} records',
    ofTotal: 'out of {{total}} records',
    jump: 'Go to page',
  },
  card: {
    net: 'Net salary',
    paidOn: 'Paid on {{date}}',
  },
  panel: {
    label: 'Selected salary',
    heading: '{{period}}',
    netMonthly: 'Net {{amount}}',
    pay: 'Pay Salary',
    reverse: 'Undo',
    edit: 'Edit',
    delete: 'Delete',
    thisMonth: 'This period’s payment',
    paidOn: 'Paid on {{date}}',
    paidAmount: 'Net amount paid',
    amounts: 'Amounts',
    history: 'Payment history',
    noHistory: 'No payments yet.',
  },
  bulk: {
    title: 'Bulk Salary Payment Preview',
    subtitle: '{{period}}',
    count: 'Employees to Pay',
    totalNet: 'Total Net Payment',
    totalCost: 'Total Cost',
    note: 'Extra payments and deductions change the net salary. “Pay Travel” sets the same extra payment for everyone.',
    cardLine: 'Gross {{gross}} · Deductions {{deductions}}',
    total: 'Total',
    columns: {
      employee: 'Employee',
      grossSalary: 'Gross Salary',
      totalDeductions: 'Deductions',
      additionalPayment: 'Extra Payment',
      additionalDeduction: 'Extra Deduction',
      netSalary: 'Net Salary',
      totalEmployerCost: 'Total Cost',
    },
    yolOde: 'Pay Travel',
    confirm: 'Confirm and Complete Payment',
  },
  yol: {
    title: 'Travel Allowance',
    subtitle: 'Added to everyone as an extra payment',
    amount: 'How much is the travel allowance?',
    placeholder: 'Enter an amount…',
    hint: 'The extra payment of the {{count}} employees in the preview becomes this amount.',
    apply: 'Apply',
  },
  confirm: {
    reverseTitle: 'Undo the payment?',
    reverseMessage: 'Undo the {{period}} salary payment of {{name}}?',
    deleteTitle: 'Delete the salary record?',
    deleteMessage: 'The current salary record of {{name}} and the payment history on it will be deleted permanently.',
  },
  common: {
    cancel: 'Cancel',
  },
  toast: {
    loadError: 'Error loading salaries',
    nothingToPay: 'There are no salaries to pay for this month',
    bulkPaid: 'Salary payment completed for {{count}} employees',
    paid: 'Salary of {{name}} paid',
    alreadyPaid: 'The salary of {{name}} for this month is already paid',
    notPaid: 'The salary of {{name}} for this month is not paid',
    payError: 'An error occurred during the payment',
    reversed: 'Salary payment of {{name}} undone',
    reverseError: 'Error while undoing the payment',
    deleted: 'Salary deleted',
    deleteError: 'Error deleting the salary',
    pageJumpInvalid: 'Please enter a page number between 1 and {{max}}.',
  },
};

export default salaryPayment;
